export const MISSED = 'visitMissed'
export const DECLINED = 'visitDeclined'
export const ERROR = 'visitError'
